import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  MenuItem
} from 'components/Menu'
import KanBoIcon from 'components/KanBoIcon'
import ActivityContentComponent, {
  ActivityAction
} from 'components/ActivityContent'
import classes from './ActivityContent.module.scss'

export class ActivityContent extends React.Component {
  static propTypes = {
    boardContext: PropTypes.object.isRequired,

    isBookmarked: PropTypes.bool.isRequired,

    requestAddBookmark: PropTypes.func.isRequired,
    requestRemoveBookmark: PropTypes.func.isRequired,
  }

  handleAddBookmarkClick = () => {
    const { boardContext, id, requestAddBookmark } = this.props

    requestAddBookmark({
      boardId: boardContext.id,
      id
    })
  }

  handleRemoveBookmarkClick = () => {
    const { boardContext, id, requestRemoveBookmark } = this.props

    requestRemoveBookmark({
      boardId: boardContext.id,
      id
    })
  }

  render () {
    const {
      isBookmarked,

      requestRemoveMessage,
      requestAddBookmark,

      ...props
    } = this.props

    return (
      <ActivityContentComponent
        {...props}
        actions={
          isBookmarked && (
            <ActivityAction
              className={classes.bookmark}
              icon={
                <KanBoIcon name='kanbo-16-solid-bookmarked' />
              }
              onClick={this.handleRemoveBookmarkClick}
            />
          )
        }
        menu={
          isBookmarked ? (
            <MenuItem
              icon={<KanBoIcon fixedWidth name='kanbo-16-unbookmark' />}
              onClick={this.handleRemoveBookmarkClick}
            >
              <FormattedMessage id='BOOKMARK_REMOVE' />
            </MenuItem>
          ) : (
            <MenuItem
              icon={<KanBoIcon fixedWidth name='kanbo-16-bookmark' />}
              onClick={this.handleAddBookmarkClick}
            >
              <FormattedMessage id='BOOKMARK_ADD' />
            </MenuItem>
          )
        }
      />
    )
  }
}

export default ActivityContent
